import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import ExtraOptions from 'vue-match-media';
import GmapVue from 'gmap-vue';
import gMapOptions from '@/config/plugins/gMapVueOptions';
import { isGoogleMaps } from '@/config/map';
import vueGtmOptions from '@/config/plugins/vueGtmOptions';
import InfiniteLoading from 'vue-infinite-loading';
import StoryblokVue from 'storyblok-vue';
import VCalendar from 'v-calendar';
import VScrollLock from 'v-scroll-lock';
import Vuelidate from 'vuelidate';
import VueAxios from 'vue-axios';
import VueClipboard from 'vue-clipboard2';
import VueCompositionAPI from '@vue/composition-api';
import VueCurrencyInput from 'vue-currency-input';
import VueGtm from 'vue-gtm';
import VueMask from 'v-mask';
import VueSocialSharing from 'vue-social-sharing';
import Vue2TouchEvents from 'vue2-touch-events';
const VueScrollTo = require('vue-scrollto');
const VueShortKey = require('vue-shortkey');
VueClipboard.config.autoSetContainer = true;
const plugins = [
    { plugin: Vuelidate },
    { plugin: VueCompositionAPI },
    {
        plugin: VueCurrencyInput,
        options: { globalOptions: { allowNegative: false } }
    },
    { plugin: VueSocialSharing },
    { plugin: StoryblokVue },
    { plugin: InfiniteLoading },
    { plugin: Vue2TouchEvents },
    { plugin: VueShortKey, options: { prevent: ['input', 'textarea'] } },
    { plugin: VueScrollTo },
    { plugin: VueClipboard },
    { plugin: VueAxios, options: axios },
    { plugin: ExtraOptions },
    { plugin: VCalendar },
    { plugin: VScrollLock },
    { plugin: VueMask, options: { placeholders: { N: null } } },
    { plugin: Vuex },
    { plugin: VueGtm, options: vueGtmOptions }
];
/**
 * Register Vue global plugins
 */
export const registerGlobalPlugins = () => {
    /*
     * gmap-vue is installed only when Google is the configured map provider.
     *
     * `dynamicLoad: false` in gMapVueOptions means the plugin injects the
     * Google Maps JS API script at install time, not on first map render -- so
     * registering it unconditionally would keep every page calling
     * maps.googleapis.com (and failing on a missing key) even with
     * VUE_APP_MAP_PROVIDER=osm. See docs/google-maps-to-osm.md.
     */
    if (isGoogleMaps()) {
        Vue.use(GmapVue, gMapOptions);
    }
    plugins.forEach((plugin) => {
        Vue.use(plugin.plugin, plugin.options || {});
    });
};
